
/* eslint-disable react/prop-types */ // remove
/* eslint-disable react/destructuring-assignment */ // remove

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import createTime from './utils/createTime.js';
import { EditedIcon } from '../../../components/icons/index'
import { calculateIsFirst, calculateIsLast } from './utils/common.js';

import { MessageSubtypes, MessageTypes } from './constants';

const withMessage = MessageChild => {
  const Message = props => {
    const [isFirst, setIsFirst] = useState(calculateIsFirst(props));
    const [isLast, setIsLast] = useState(calculateIsLast(props));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
      setIsFirst(calculateIsFirst(props));
      setIsLast(calculateIsLast(props));

      return () => {};
    });

    const createMessageTime = () => {
      const { date, showTime, type, subtype } = props;
      const shouldShowTime = !!date
        && showTime
        && subtype !== MessageSubtypes.PREVIEW
        && (isFirst || type === MessageTypes.SYSTEM);

      if (!shouldShowTime) {
        return null;
      }

      return <p className="message-time">{createTime(date)}</p>;
    };

    const createLastEditedTime = () => {
      const { lastEditedTime } = props;

      if (lastEditedTime === '0' || !lastEditedTime) {
        return null;
      }

      return <p className="last-edited-time"><EditedIcon />{`${createTime(lastEditedTime)}`}</p>
    };

    // if (props.isFake && Date.now() - props.date > 15e3) { // remove
    //   console.error(`Fake message older than 15 seconds. date = ${props.date}`); // remove
    // } // remove

    return (
      <MessageChild
        messageTime={createMessageTime()}
        lastEditedTimeComponent={createLastEditedTime()}
        isFirstInGroup={isFirst}
        isLastInGroup={isLast}
        {...props}
      />
    );
  };

  if (process.env.NODE_ENV !== 'production') {
    Message.propTypes = {
      nickname: PropTypes.string.isRequired,
      messageViewType: PropTypes.string,
      onScrollDown: PropTypes.func.isRequired,
      date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      lastEditedTime: PropTypes.string,
      showTime: PropTypes.bool,
      type: PropTypes.string,
      subtype: PropTypes.string,
      text: PropTypes.string,
      prevMessageParams: PropTypes.object,
      nextMessageParams: PropTypes.object,
      toolParams: PropTypes.object,
    };
  }

  return Message;
};


export default withMessage;
